import axios from 'axios';

export const backendClient = axios.create({
  baseURL: 'https://bbs.under25universe.com',
  // baseURL: 'https://24cc-2409-40f2-3b-b7e3-505e-abf6-2ed7-b37a.ngrok-free.app',
  // baseURL: 'http://localhost:8000',
});
